"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialEntityState = getInitialEntityState;
exports.createInitialStateFactory = createInitialStateFactory;

function getInitialEntityState() {
  return {
    ids: [],
    entities: {}
  };
} // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types


function createInitialStateFactory() {
  // eslint-disable-next-line @typescript-eslint/ban-types
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function getInitialState(additionalState) {
    return Object.assign(getInitialEntityState(), additionalState);
  }

  return {
    getInitialState: getInitialState
  };
}